import styled from 'styled-components'
import { devices } from '../../devices'

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.72);
    z-index: 1000;

    @media only screen and ${devices.sm} {
        padding: 12px;
    }
`

export const Panel = styled.div`
    position: relative;
    width: 100%;
    max-width: 640px;
    max-height: min(85vh, 720px);
    padding: 28px 24px 24px;
    border: 2px solid ${({ theme }) => theme.colors.accentColor};
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.backgroundElemetsBlack};
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media only screen and ${devices.md} {
        max-width: 560px;
        padding: 24px 20px 20px;
    }

    @media only screen and ${devices.sm} {
        max-width: 100%;
        max-height: 88vh;
        padding: 22px 16px 18px;
        border-radius: 12px;
    }
`

export const CloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: ${({ theme }) => theme.colors.white};
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.2s, background-color 0.2s;

    &:hover,
    &:focus-visible {
        color: ${({ theme }) => theme.colors.accentColor};
        background-color: rgba(255, 195, 42, 0.12);
        outline: none;
    }

    @media only screen and ${devices.sm} {
        top: 8px;
        right: 8px;
    }
`

export const HighlightAddress = styled.span`
    color: ${({ theme }) => theme.colors.accentColor};
    font-weight: 600;
`

export const Text = styled.p`
    margin: 0;
    padding-right: 36px;
    color: ${({ theme }) => theme.colors.white};
    font-size: 17px;
    line-height: 1.65;
    letter-spacing: 0.01em;
    white-space: pre-line;
    word-break: break-word;

    @media only screen and ${devices.md} {
        font-size: 16px;
        line-height: 1.6;
    }

    @media only screen and ${devices.sm} {
        padding-right: 28px;
        font-size: 15px;
        line-height: 1.55;
    }

    @media only screen and ${devices.xs} {
        font-size: 14px;
    }
`
